import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName";
import { BroadcastQueParams } from "@service/components/background-view/types/BroadcastQueParams";
import {MutationTree} from "vuex";
import { BackgroundViewState } from "../types/BackgroundViewState";
import Vue from 'vue'

export const mutations: MutationTree<BackgroundViewState> = {
    setQue(state, payload) {
        Vue.set(state, "broadcastQue", payload)
    },
    updateQue(state, { viewName, isLive }: BroadcastQueParams) {
        Vue.set(state.broadcastQue, viewName, { isLive: isLive })
    },
    setSingleBroadcast(state, { viewName, isLive, id }: BroadcastQueParams) {
        Vue.set(state, "broadcastQue", { [viewName]: { isLive: isLive, id: id } })
    },
    deleteFromQue(state, payload: BackgroundViewName) {
        Vue.delete(state.broadcastQue, payload);
    }
}
